/**

// Check if debug mode is enabled (global)
const urlParams = new URLSearchParams(window.location.search);

 * Search UI Module - UI компоненты и визуализация поиска
 */

(function(window) {
    'use strict';

    const SearchUI = {};

    // Константы
    const SEARCH_LIMIT = 300;

    /**
     * Обновляет прогресс-бар поиска
     */
    SearchUI.updateProgress = function(percentage) {
        const left = percentage;
        const width = 100 - percentage;
        
        $(".search-bg").animate({ "left": `${left}%`, "width": `${width}%` }, 100, "swing");
        
        const spg = $(".search-progress-badge");
        const step = Math.round(percentage / 33);
        const mode = step === 1 ? "files" : step === 2 ? "path" : "content";
        
        // Обновляем текст
        if (window.translate) {
            spg.text(window.translate("search_mode_" + mode));
            spg.prop("title", window.translate("search_mode_" + mode + "_desc"));
        }
        
        // Обновляем классы
        const sClasses = ['search-progress-badge-1', 'search-progress-badge-2', 'search-progress-badge-3'];
        const curClass = "search-progress-badge-" + step.toString();
        const otherClasses = sClasses.filter(c => c !== curClass);
        
        spg.removeClass(otherClasses.join(' '));
        if (!spg.hasClass(curClass)) { 
            spg.addClass(curClass);
        }
        
        // Обновляем кнопку полнотекстового поиска
        const btn = $(".search-button-full-text-search");
        if (percentage == 100) {
            btn.addClass("text-canvas bg-rons-grad search-progress-button");
        } else {
            btn.removeClass("text-canvas bg-rons-grad search-progress-button");
        }
    };

    /**
     * Инициализирует typeahead для поиска
     */
    SearchUI.initTypeahead = function(options = {}) {
        const {
            selector = '#fnd_searchbox',
            onInit = null,
            onError = null
        } = options;

        const searchBox = $(selector);
        if (window.HyperLog) { HyperLog.debug('SearchUI.initTypeahead: disabled'); }
        if (typeof onInit === 'function') onInit();
        setTimeout(() => { searchBox.focus(); }, 100);
        searchBox.off('input.searchUI keyup.searchUI').on('input.searchUI keyup.searchUI', function() {
            if (window.filterManager && typeof window.filterManager.handleSearchInput === 'function') {
                window.filterManager.handleSearchInput();
            }
        });
    };

    /**
     * Генерирует шаблон для элемента результата поиска
     */
    SearchUI.generateSuggestionTemplate = function(data) {

        
        // Валидация входных данных
        if (!data) {
            if (debugMode === '1') {
                console.error('[SearchUI.generateSuggestionTemplate] Data is null or undefined:', data);
            }
            return '<div class="file-item error">Template Error: No data provided</div>';
        }
        
        // Check if data is already HTML (double processing prevention)
        if (typeof data === 'string') {
            if (debugMode === '1') {
                console.warn('[SearchUI.generateSuggestionTemplate] Received HTML string instead of data object, this suggests double processing');
            }
            console.warn('[SearchUI.generateSuggestionTemplate] Data preview:', data.substring(0, 100) + '...');
            return '<div class="file-item error">Template Error: Received HTML instead of data object</div>';
        }
        
        if (typeof data !== 'object') {
            if (debugMode === '1') {
                console.error('[SearchUI.generateSuggestionTemplate] Invalid data type:', typeof data, data);
            }
            return '<div class="file-item error">Template Error: Invalid data type</div>';
        }
        
        if (!data.name) {
            if (debugMode === '1') {
                console.error('[SearchUI.generateSuggestionTemplate] Missing file name in data:', data);
            }
            return '<div class="file-item error">Template Error: Missing file name</div>';
        }
        
        if (window.HyperLog) {
            HyperLog.debug("Generating suggestion template", { 
                fileName: data.name,
                filePath: data.path,
                fileSize: data.size,
                fullMode: data.fullMode
            });
        }

        // Определяем типы материала
        const materialInfo = SearchUI.detectMaterialInfo(data.path, data.name);
        
        // Форматируем размер файла
        // Размеры: data.s (KB, основная схема) или data.size (байты, fallback)
        let sizeBytes = 0;
        if (typeof data.s === 'number') {
            sizeBytes = data.s * 1000; // s is KB
        } else if (typeof data.size === 'number') {
            sizeBytes = data.size; // size is bytes
        }
        const sizeFormatted = SearchUI.formatFileSize(sizeBytes);
        
        // Создаем HTML
        let html = `<div class="file-item d-flex justify-content-between align-items-center">`;
        
        // Левая часть - информация о файле
        html += `<div class="file-info flex-grow-1">`;
        html += `<div class="file-name">${data.name}</div>`;
        if (data.path) {
            html += `<div class="file-path text-muted small">${data.path}</div>`;
        }
        html += `</div>`;
        
        // Правая часть - метаданные
        html += `<div class="file-meta d-flex align-items-center">`;
        
        // Тип материала
        if (materialInfo.materialType) {
            html += `<span class="badge bg-secondary me-2">${materialInfo.materialType}</span>`;
        }
        
        // Формат
        if (materialInfo.formatType) {
            html += `<span class="badge bg-info me-2">${materialInfo.formatType}</span>`;
        }
        
        // Язык
        if (materialInfo.language) {
            html += `<span class="badge bg-warning me-2">${materialInfo.language}</span>`;
        }
        
        // Размер
        html += `<span class="file-size text-muted">${sizeFormatted}</span>`;
        
        html += `</div>`;
        html += `</div>`;
        
        return html;
    };

    /**
     * Определяет информацию о материале
     */
    SearchUI.detectMaterialInfo = function(path, filename) {
        let materialType = "";
        let formatType = "";
        let language = "";
        
        // Проверяем что параметры существуют
        if (!filename) {
            if (debugMode === '1') {
                console.warn('[SearchUI.detectMaterialInfo] Missing filename:', { path, filename });
            }
            return {
                materialType: "",
                formatType: "",
                language: "",
                fullPath: ""
            };
        }
        
        // Path может быть пустым, обрабатываем это корректно
        const safePath = path || "";
        const fullPath = safePath ? safePath + "/" + filename : filename;
        
        // Определение типа материала
        const materialPatterns = [
            { pattern: /\/(books?|books?[_-]?\d+)\//i, type: "Book" },
            { pattern: /\/(lectures?|lrh[_-]?lectures?)\//i, type: "Lecture" },
            { pattern: /\/(pl[sb]?s?|policy[_-]?letters?)\//i, type: "Policy" },
            { pattern: /\/(hcob?s?|bulletins?)\//i, type: "Bulletin" },
            { pattern: /\/(tapes?|audio)\//i, type: "Audio" },
            { pattern: /\/(videos?|films?)\//i, type: "Video" }
        ];
        
        for (const {pattern, type} of materialPatterns) {
            if (pattern.test(fullPath)) {
                materialType = type;
                break;
            }
        }
        
        // Определение формата - с проверкой на существование точки в имени файла
        let ext = "";
        if (filename && filename.includes('.')) {
            ext = filename.split('.').pop().toLowerCase();
        }
        const formatMap = {
            'pdf': 'PDF',
            'djvu': 'DJVU',
            'doc': 'DOC',
            'docx': 'DOCX',
            'txt': 'TXT',
            'mp3': 'MP3',
            'mp4': 'MP4',
            'avi': 'AVI',
            'wmv': 'WMV'
        };
        
        formatType = formatMap[ext] || (ext ? ext.toUpperCase() : "Unknown");
        
        // Определение языка
        if (window.LanguageManager) {
            language = window.LanguageManager.detectMaterialLanguage(fullPath);
        }
        
        return {
            materialType,
            formatType,
            language,
            formatTypeByExt: ext
        };
    };

    /**
     * Форматирует размер файла
     */
    SearchUI.formatFileSize = function(bytes) {
        // Валидация входных данных
        if (bytes === null || bytes === undefined || isNaN(bytes)) {
            return 'Unknown size';
        }
        
        bytes = Number(bytes);
        if (bytes === 0) return '0 B';
        
        const k = 1000;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.min(sizes.length - 1, Math.floor(Math.log(bytes) / Math.log(k)));
        
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    };

    /**
     * Настраивает события typeahead
     */
    SearchUI.setupTypeaheadEvents = function(selector = '#fnd_searchbox') {
        const searchBox = $(selector);
        
        // Событие открытия
        searchBox.on('typeahead:opened', function() {
            if (window.HyperLog) {
                HyperLog.debug("Typeahead menu opened");
            }
        });
        
        // Событие закрытия
        searchBox.on('typeahead:closed', function() {
            if (window.HyperLog) {
                HyperLog.debug("Typeahead menu closed");
            }
        });
        
        // Событие выбора
        searchBox.on('typeahead:selected', function(e, data) {
            if (window.HyperLog) {
                HyperLog.debug("File selected", {
                    fileName: data.name,
                    filePath: data.path
                });
            }
            
            // Здесь можно добавить логику обработки выбора файла
            SearchUI.handleFileSelection(data);
        });
        
        // CRITICAL: Handle search input changes
        searchBox.off('input.searchUI keyup.searchUI').on('input.searchUI keyup.searchUI', function(e) {
            const query = $(this).val();
            if (debugMode === '1') {
                console.log('[SearchUI] Search input changed:', query);
            }
            
            // CRITICAL: Only trigger filter manager, not search callback
            // This prevents duplicate filtering
            if (window.filterManager && typeof window.filterManager.handleSearchInput === 'function') {
                window.filterManager.handleSearchInput();
            }
            
            // Don't trigger search callback to avoid conflicts
            // Search callback is handled by FilterManager now
        });
        
        // TEMPORARY: Disable automatic search triggering to debug
        if (debugMode === '1') {
                console.log('[SearchUI] Search input event handlers set up');
            }
        
        // Обработка клавиш
        searchBox.on('keyup', function(e) {
            if (window.HyperLog) {
                HyperLog.debug("Key pressed in search box", { 
                    key: e.key,
                    value: $(this).val()
                });
            }
        });
    };

    /**
     * Обрабатывает выбор файла
     */
    SearchUI.handleFileSelection = function(fileData) {
        // Здесь можно реализовать логику обработки выбранного файла
        // Например, открытие файла, показ детальной информации и т.д.
        if (debugMode === '1') {
                console.log("File selected:", fileData);
            }
    };

    /**
     * Тестирует функциональность typeahead
     */
    SearchUI.testTypeaheadFunctionality = function(selector = '#fnd_searchbox') {
        const searchBox = $(selector);
        
        if (window.HyperLog) {
            HyperLog.debug("Testing typeahead functionality");
        }
        
        // Проверяем наличие обработчиков событий
        const events = $._data(searchBox[0], 'events');
        const hasTypeaheadEvents = events && (events['typeahead:opened'] || events['input']);
        
        if (!hasTypeaheadEvents) {
            // Переинициализируем
            searchBox.removeClass('tt-input');
            $('.tt-menu').remove();
            setTimeout(() => {
                SearchUI.initTypeahead({ selector });
            }, 100);
        } else {
            // Устанавливаем фокус
            setTimeout(() => {
                searchBox.focus();
            }, 100);
        }
    };

    /**
     * Уничтожает typeahead
     */
    SearchUI.destroyTypeahead = function(selector = '#fnd_searchbox') {
        const searchBox = $(selector);
        
        try {
            searchBox.typeahead('destroy');
        } catch(e) {
            console.debug("Typeahead destroy failed (expected if not initialized)");
        }
        
        searchBox.removeClass('tt-input');
        $('.tt-menu').remove();
    };

    // Экспорт модуля
    window.SearchUI = SearchUI;

    // Для обратной совместимости
    window.searchProgress = SearchUI.updateProgress;
    window.generateSuggestionTemplate = SearchUI.generateSuggestionTemplate;
    window.initializeTypeahead = function() { SearchUI.initTypeahead(); };
    window.setupTypeaheadEvents = function() { SearchUI.setupTypeaheadEvents(); };
    window.testTypeaheadFunctionality = function() { SearchUI.testTypeaheadFunctionality(); };

    // ES Module export for modern imports
    if (typeof window !== 'undefined') {
        window.searchUI = SearchUI;
    }

})(window); 

// ES Module export
    /**
     * ЗАГЛУШКИ для main-init.js API
     */
    SearchUI.init = function(config) {
        return this;
    };

    SearchUI.updateSearchStatus = function(count, query) {
        return this;
    };

    SearchUI.onSearch = function(callback) {
        if (debugMode === '1') {
                console.log('[SearchUI] onSearch callback registered');
            }
        this._searchCallback = callback;
        return this;
    };

    SearchUI.onClear = function(callback) {
        if (debugMode === '1') {
                console.log('[SearchUI] onClear callback registered');
            }
        this._clearCallback = callback;
        return this;
    };

    SearchUI.clearSearch = function() {
        if (debugMode === '1') {
                console.log('[SearchUI] clearSearch called');
            }
        return this;
    };

    SearchUI.handleResize = function() {
        if (debugMode === '1') {
                console.log('[SearchUI] handleResize called');
            }
        return this;
    };

export const searchUI = window.SearchUI || {}; 